module.exports = __webpack_public_path__ + "img/ShaderEditorBasicParticleEffect.968a7436.gif";